import ProfileTransferComponent from '../../components/GoldRedirect/ProfileTransfer';
import GoldRedirectCard from '../../components/GoldRedirect/GoldRedirectCard';

export default {
  Prelogin: { Component: GoldRedirectCard },
  Preregistration: { Component: GoldRedirectCard },
  ProfileTransfer: { Component: ProfileTransferComponent },
};
